import React from 'react';
import { IconFill, IconFillProps, IconOutline } from '@ant-design/icons-react-native';
import type { TChatTabBarIconProps } from '../../types';

export const ChatTabBarIcon = ({ focused, size, color }: TChatTabBarIconProps) => {
    if (focused) {
        return <IconFill name={'message' as IconFillProps['name']} size={size} color={color} />;
    }
    return <IconOutline name={'message' as any} size={size} color={color} />;
};
